"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var forgot_password_controller_1 = __importDefault(require("./forgot-password.controller"));
var forgot_password_html_1 = __importDefault(require("./forgot-password.html"));
function config($stateProvider, $urlRouterProvider) {
    $stateProvider.state("drivecoach.forgotpassword", {
        url: "/forgot-password",
        controller: forgot_password_controller_1.default,
        controllerAs: "vm",
        template: forgot_password_html_1.default,
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];
exports.default = angular_1.default
    .module("forgotpassword", [])
    .config(config)
    .controller("ForgotPasswordController", forgot_password_controller_1.default);
